import {pxToEm} from "utils/styles/style_helpers";

export default theme =>({
    adstxtindicator:{
        display: 'flex',
        alignItems: 'center',
        color: theme.color.neutral.medium.swatch,
        '& .indicator-ball':{
            height: pxToEm(14),
            width: pxToEm(14),
            borderRadius: 50,
            margin: pxToEm(10),
            '&.installed-true':{
                background: theme.color.secondary.medium.swatch
            },
            '&.installed-false':{
                background: theme.color.attention.light.contrast
            }
        }
    }
})